import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IndicateurModel } from '../../models/IndicateurModel';
import { CacheService } from '../../services/cache-service';
import { ConfigurationService } from '../../services/configuration.service';
import { GuidService } from '../../services/guid.service';

@Component({
  selector: 'indicateur-dropdown',
  templateUrl: './indicateur-dropdown.component.html',
  styleUrls: ['./indicateur-dropdown.component.css'],
})
export class IndicateurDropdownComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() showClear: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = ''; // Sélectionner un taux de TVA
  pDropdownStyle: any = {};
  minWidth: string = '84px';

  private _indicateurId: number;
  @Input()
  set indicateurId(value: number) {
    this._indicateurId = value;
    this.selectIndicateur();
  }
  get indicateurId(): number {
    return this._indicateurId;
  }

  _indicateur: IndicateurModel = null;
  @Input()
  set indicateur(value: IndicateurModel) {
    this._indicateur = value;
  }
  get indicateur(): IndicateurModel {
    return this._indicateur ? this._indicateur : null;
  }

  @Output() indicateurIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() indicateurChange: EventEmitter<IndicateurModel> = new EventEmitter<IndicateurModel>();

  public indicateurs: IndicateurModel[] = [];
  public guid: string;
  public indicateursLoaded: boolean = false;

  constructor(
    configurationService: ConfigurationService,
    private guidService: GuidService,
    private cacheService: CacheService,
  ) {
    this.pDropdownStyle = { ...configurationService.pDropdownStyle, 'min-width': this.minWidth };
  }

  ngOnInit() {
    this.guid = this.guidService.newGuid();
    if (!this.indicateursLoaded) {
      this.loadIndicateurs();
    } else {
      this.selectIndicateur();
    }
  }

  selectIndicateur() {
    if (this.indicateursLoaded) {
      setTimeout(() => {
        this.indicateur = this.indicateurs.find(t => this._indicateurId != null && this._indicateurId != undefined && t.Id == this._indicateurId);
      });
    }
  }

  loadIndicateurs() {
    this.cacheService.getIndicateurs().subscribe(indicateurs => {
      this.indicateurs = indicateurs;
      this.indicateursLoaded = true;
      this.selectIndicateur();
    });
  }

  indicateurChanged() {
    if (this.indicateursLoaded) {
      if (this._indicateurId != this._indicateur?.Id) {
        this._indicateurId = this._indicateur?.Id;
        this.indicateurIdChange.emit(this._indicateurId);
        this.indicateurChange.emit(this._indicateur);
      }
    }
  }
}
